(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER, OBRA_MUSEO_FORM_ADMIN) {
        var config = OBRA_MUSEO_FORM_ADMIN();
        var base = "admin/museos/obraMuseo";
        var params = {
            parent: "admin/museos/salaMuseo",
            view: 'contentChildren',
            base: base,
            baseUrl: "/{salaid:int}/obra",
            translateBase: "museos.obraMuseo.admin.",
            templateList: '<obra-museo-list-admin></obra-museo-list-admin>',
            templateForm: config.component
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    template: '<ng-include src="\'app/components/aspg/museos/admin/museos-breadcrumb.admin.html\'"></ng-include>' +
                    '<div ui-view="contentChildren"></div>'
                }
            },
            resolve: {
                /* @ngInject */
                sala: function ($stateParams, SalaMuseo) {
                    // TODO: ¿Optimizar y obtener sólo ID y nombre?
                    if ($stateParams.salaid) {
                        return SalaMuseo.get({id: $stateParams.salaid}).$promise;
                    } else return {};
                }
            }
        });
        // Listar
        angular.merge(state.list, {});
        // Crear
        angular.merge(state.create, {
            resolve: config.resolve
        });
        // Editar
        angular.merge(state.edit, {
            resolve: angular.merge(config.resolve, {
                /* @ngInject */
                item: function (ObraMuseo, $stateParams) {
                    return ObraMuseo.get({id: $stateParams.id}).$promise;
                }
            })
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)
            .state(state.create.name, state.create)
            .state(state.edit.name, state.edit);
    }
})();
